/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_No_Event_Group_Selected_MessageInputs */

const en_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event group is currently selected`)
};

const fr_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe d'evenements selectionne`)
};

const de_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist derzeit keine Ereignisgruppe ausgewählt.`)
};

const it_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo di eventi è attualmente selezionato`)
};

const ru_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В данный момент группа мероприятий не выбрана.`)
};

const es_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún grupo de eventos seleccionado actualmente`)
};

const zh_cn2_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前未选择任何事件组。`)
};

const ja_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在イベントグループが選択されていません`)
};

const hi_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान में कोई इवेंट समूह चयनित नहीं है`)
};

const pt_pt2_iframe_remote_no_event_group_selected_message = /** @type {(inputs: Iframe_Remote_No_Event_Group_Selected_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum grupo de eventos está selecionado no momento.`)
};

/**
* | output |
* | --- |
* | "No event group is currently selected" |
*
* @param {Iframe_Remote_No_Event_Group_Selected_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_no_event_group_selected_message = /** @type {((inputs?: Iframe_Remote_No_Event_Group_Selected_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_No_Event_Group_Selected_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "de") return de_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "it") return it_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "ru") return ru_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "es") return es_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "ja") return ja_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "hi") return hi_iframe_remote_no_event_group_selected_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_no_event_group_selected_message(inputs)
	return en_iframe_remote_no_event_group_selected_message(inputs)
});